import {Master} from './master';

export class MasterListPage {

  currentPage: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  firstRowOnPage: number;
  lastRowOnPage: number;
  private pResults: Master[];


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): Master[] {
    return this.pResults;
  }

  public set results(list: Master[]) {
    if (list != null) {
      this.pResults = list.map(t => new Master(t));
    }
  }

}
